import { createIcon } from '@chakra-ui/icons';

export const SportsIcon = createIcon({
  displayName: 'SportsIcon',
  viewBox: '0 0 28 27',
  d: 'M14 .168c3.333 0 6.333 1.2 8.666 3.2A13.309 13.309 0 0018 13.501a13.31 13.31 0 004.666 10.134c-2.333 2-5.333 3.2-8.666 3.2-3.334 0-6.333-1.2-8.667-3.2A13.308 13.308 0 0010 13.5 13.31 13.31 0 005.333 3.368c2.334-2 5.333-3.2 8.667-3.2zm13.333 13.333c0 3.094-1.053 5.934-2.826 8.2a10.659 10.659 0 01-3.84-8.2c0-3.293 1.493-6.24 3.84-8.2a13.248 13.248 0 012.826 8.2zm-26.666 0c0-3.093 1.053-5.933 2.826-8.2a10.659 10.659 0 013.84 8.2c0 3.294-1.493 6.24-3.84 8.2a13.248 13.248 0 01-2.826-8.2z',
});
